import i18n from "@/i18n";
import ExcelDownColumn from "./ExcelDownColumn";

export const exportLogTable = () => {
    return {
        columns: [
            {
                colId: "orderNum",
                header: i18n.t("zhiji.robotLog.downDetailColumn.orderNum"),
                type: "Text",
                width: "7%"
            },
            {
                colId: "timeQuantum",
                header: i18n.t("zhiji.robotLog.downDetailColumn.dataTime"),
                type: "Text",
                width: "32%"
            },{
                colId: "exportSuccess",
                header: i18n.t("zhiji.robotLog.downDetailColumn.exportResult"),
                type: "Text",
                width: "20%"
            },
            {
                colId: "exportProgress",
                header: i18n.t("zhiji.robotLog.downDetailColumn.currentStatus"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "creator",
                header: i18n.t("zhiji.robotLog.downDetailColumn.creator"),
                type: "Text",
                width: "14%"
            },
            {
                colId: "operate",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "10%",
                component: ExcelDownColumn
            }
        ],
        pageLengthRank: [10, 20, 30, 100],
        pageLength: 10
    };
};
